import { LabelMode } from "src/utils/label-mode.enum";
import { CommonModule } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SharedModule } from "src/shared/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SetError } from "src/utils/set-error.validator";
import { CartService } from "src/app/services/api/carts.service";

@Component({
  selector: "app-discount-code",
  imports: [SharedModule, CommonModule, TranslateModule, ReactiveFormsModule],
  templateUrl: "./discount-code.component.html",
  styleUrl: "./discount-code.component.scss",
})
export class DiscountCodeComponent implements OnInit {
  #dialogRef = inject(MatDialogRef<DiscountCodeComponent>);
  #fb = inject(FormBuilder);
  #cartService = inject(CartService);

  data = inject(MAT_DIALOG_DATA);

  LabelMode = LabelMode;
  errors = signal<{ code: any } | undefined>(undefined);

  form: FormGroup;

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.#fb.group({
      code: [null, Validators.required],
      total_net_price: [this.data?.userCart?.total_net_price],
    });
  }

  async verifyCode() {
    this.errors.set(undefined);
    if (this.form.invalid) {
      this.errors.update((_) => SetError(this.form));
      return;
    }
    const payload = this.form.getRawValue();

    this.#cartService
      .verifyDiscountCode(payload)
      .pipe()
      .subscribe({
        next: (res) => {
          this.#dialogRef.close(res);
        },
        error: (error) => {
          const apiError = { code: [error.error.errors] };
          this.errors.update((_) => SetError(this.form, apiError));
        },
        complete: () => {},
      });
  }
  onClose() {
    this.#dialogRef.close();
  }
}
